/**
 * @generated SignedSource<<282270b2748c99f14eaab738366c2859>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsIcon_viewer$data = {
  readonly conversations?: {
    readonly metadata: {
      readonly lastUnreadMessageDate: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NotificationsIcon_viewer";
};
export type NotificationsIcon_viewer$key = {
  readonly " $data"?: NotificationsIcon_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsIcon_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsIcon_viewer",
  "selections": [
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            }
          ],
          "concreteType": "ConversationConnection",
          "kind": "LinkedField",
          "name": "conversations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastUnreadMessageDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "conversations(filter:\"showUnreadOnly\")"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e8c858af1ede513cc69333667b080eac";

export default node;
